<template>
  <v-btn text class="avatar-button" @click="$emit('click', $event)">
    <v-avatar size="30" class="mr-1" :color="avatarColor">
      <img :src="src" />
    </v-avatar><slot>Button Text</slot>
  </v-btn>
</template>

<script>
export default {
  name: "avatarButton",
  props: ["image", "avatarColor"],
  computed: {
    src(){
      return require("../../assets/" + this.image);
    }
  }
}
</script>